

import { Middleware } from 'redux'
import { callSocketOpened, callSocketClosed, callIncomingMessageReceived, callSetAvailable, billingIncomingMessageReceived, callSetUniqueDeviceId, logoutIncomingMessageReceived } from './callSlice';

import { uid } from '@ht/shared/methods';


const callMiddleware: Middleware = store => {
    let ws: WebSocket;
    let avail = true;
    let tries = 0;
    let uniqueDeviceId = "";
    let isConnecting = false;
    const initConnection = () => {
        const { user } = store.getState().auth;
        const domain = process.env.REACT_APP_WSCN_ADDRESS;
        const userid = user?.userId;
        const username = user?.username;
        uniqueDeviceId = `${user?.deviceId}${uid(4)}`;

        if (uniqueDeviceId) {
            ws = new WebSocket(`${domain}?device_id=${uniqueDeviceId}&user_id=${userid}&username=${username}&domain=${window.location.host}`);
            isConnecting = true
            ws.onclose = () => {
                isConnecting = false
                console.log("disconnecting from call notification server")
                store.dispatch(callSocketClosed());
                store.dispatch(callSetAvailable(false))
            }
            ws.onopen = () => {
                isConnecting = false
                store.dispatch(callSocketOpened());
                store.dispatch(callSetAvailable(true))
                store.dispatch(callSetUniqueDeviceId(uniqueDeviceId));
                avail = true
                tries = 0
            };
            ws.onmessage = (e: any) => {
                isConnecting = false
                const receivedMessage = JSON.parse(e.data);
                if (receivedMessage.msg_type == "BILLING")
                    store.dispatch(billingIncomingMessageReceived(receivedMessage))
                else if (receivedMessage.msg_type == "LOGOUT") {
                    if (receivedMessage.device_id == uniqueDeviceId) {
                        console.log("logout command accepted")
                        store.dispatch(logoutIncomingMessageReceived(true))
                    }
                } else {
                    store.dispatch(callIncomingMessageReceived(receivedMessage));
                }
            };

            ws.onerror = (e: any) => {
                console.log("error vonnecting", tries, e);
                tries++;
                store.dispatch(callSetAvailable(false))
                isConnecting = false
            };
        }
    }
    const shouldInitConnection = () => {
        return avail && (ws?.readyState !== 1 || !ws) && tries <= 3
    }
    return next => action => {

        const actionString = action.type.toString().split('/')[1]
        switch (actionString) {
            case "callWSStartConnecting":
                initConnection()
                setInterval(() => {

                    if (!avail) {
                        ws?.close();
                    }
                    if (shouldInitConnection() && !isConnecting) {
                        console.log("Initiating connection")
                        initConnection();
                    }
                }, 5000)
                break;
            case "setAvailable":
                avail = action.payload
                tries = 0
                break;
            case "callWSDisconnect":
                ws?.close();
                break;
            case "callSendMessage":
                try {
                    ws.send(action.payload.content);
                } catch (e) {
                    console.log("ERROR", e)
                }
                break;
        }
        next(action);
    }
}

export default callMiddleware;